// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import useIsInPwa from "@store/Framework/Common/Utilities/useIsInPwa";
import InShellEditNotice from "@store/Library/Components/InShellEditNotice/InShellEditNotice";
import React from "react";

const enum fields {
    activeZones = "activeZones",
}

interface OwnProps extends WidgetProps {
    [fields.activeZones]: string;
}

export interface PwaContentStyles {}

export const PwaConditionalContent = ({ id, fields: { activeZones } }: OwnProps) => {
    const { isEditing, isInShell } = useShellContext();
    const isInPwa = !isInShell && useIsInPwa();
    const hasBothZones = activeZones === "both";
    const hasIsInPwaZone = hasBothZones || activeZones === "InPwaOnly";
    const hasIsInBrowserZone = hasBothZones || activeZones === "InBrowserOnly";

    const ZoneBlock = ({ zoneName }: { zoneName: string }) => (
        <>
            <InShellEditNotice>{zoneName}</InShellEditNotice>
            <Zone zoneName={zoneName} contentId={id} />
        </>
    );

    const pwaOnlyContentBlocks = <ZoneBlock zoneName="PwaOnlyContentBlocks" />;
    const browserOnlyContentBlocks = <ZoneBlock zoneName="BrowserOnlyContentBlocks" />;

    return isEditing ? (
        <>
            {hasIsInPwaZone && pwaOnlyContentBlocks}
            {hasIsInBrowserZone && browserOnlyContentBlocks}
        </>
    ) : isInPwa && hasIsInPwaZone ? (
        pwaOnlyContentBlocks
    ) : !isInPwa && hasIsInBrowserZone ? (
        browserOnlyContentBlocks
    ) : null;
};

const widgetModule: WidgetModule = {
    component: PwaConditionalContent,
    definition: {
        group: "Basic",
        icon: "box",
        fieldDefinitions: [
            {
                name: fields.activeZones,
                displayName: "Active Zone(s)",
                tooltip:
                    "Decide if you want to use only one or both zones. For example, if you don't need the BrowserOnly Zone, you can set this to 'Pwa Only' to remove the unnecessary zone.",
                tooltipPosition: "left",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "Both",
                        value: "both",
                    },
                    {
                        displayName: "Pwa Only",
                        value: "InPwaOnly",
                    },
                    {
                        displayName: "Browser Only",
                        value: "InBrowserOnly",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
